import { environment } from 'src/environments/environment';

export const FlowForecastMapConstants = {
  FloodForecastMapOptions: {
    southZone: {
      minZoom: 6,
      maxZoom: 18,
      zoom: 7,
      center: [16.403274736612818, 78.83789062500001],
      zoomControl: true,
      zoomAnimation: true,
      shpBoundaryOptions: {
        layerName: 'SOUTHZONE_BOUNDARY'
      },
      maxBoundsViscosity: 1.0,
      scrollWheelZoom: false,
      attributionControl: false
      // preferCanvas : true
    },
    ap: {
      minZoom: 6,
      maxZoom: 24,
      zoom: 7,
      center: [16.035254862350413, 80.10131835937501],
      zoomControl: false,
      zoomAnimation: true,
      shpBoundaryOptions: {
        layerName: 'AP_BOUNDARY'
      },
      maxBoundsViscosity: 1.0,
      scrollWheelZoom: false,
      attributionControl: false
      // preferCanvas : true
    },
    godavariBasin: {
      minZoom: 6,
      maxZoom: 18,
      zoom: 7,
      center: [19.189271694646738, 78.77197265625001],
      zoomControl: false,
      zoomAnimation: true,
      shpBoundaryOptions: {
        cql_filter: 'ba_name = \'Godavari\'',
        layerName: 'INDIA_BASIN'
      },
      maxBoundsViscosity: 1.0,
      scrollWheelZoom: false,
      attributionControl: false
      // preferCanvas : true
    },
    krishnaBasin: {
      minZoom: 5,
      maxZoom: 24,
      zoom: 7,
      center: [16.12762353836471, 76.30554199218751],
      zoomControl: false,
      zoomAnimation: true,
      shpBoundaryOptions: {
        cql_filter: 'ba_name = \'Krishna\'',
        layerName: 'INDIA_BASIN'
      },
      maxBoundsViscosity: 1.0,
      scrollWheelZoom: false,
      attributionControl: false
      // preferCanvas : true
    },
    pennarBasin: {
      minZoom: 5,
      maxZoom: 24,
      zoom: 8,
      center: [14.4473668344672, 78.3375102280954],
      zoomControl: false,
      zoomAnimation: true,
      shpBoundaryOptions: {
        cql_filter: 'ba_name = \'Pennar\'',
        layerName: 'INDIA_BASIN'
      },
      maxBoundsViscosity: 1.0,
      scrollWheelZoom: false,
      attributionControl: false
      // preferCanvas : true
    },
    vamsadharaBasin: {
      minZoom: 5,
      maxZoom: 24,
      zoom: 9,
      center: [19.2615018937754, 83.8672197674548],
      zoomControl: false,
      zoomAnimation: true,
      shpBoundaryOptions: {
        cql_filter: 'ba_name = \'Vamsadhara\'',
        layerName: 'INDIA_BASIN'
      },
      maxBoundsViscosity: 1.0,
      scrollWheelZoom: false,
      attributionControl: false
      // preferCanvas : true
    },
    nagavaliBasin: {
      minZoom: 5,
      maxZoom: 24,
      zoom: 9,
      center: [18.8838512922589, 83.4126418918114],
      zoomControl: false,
      zoomAnimation: true,
      shpBoundaryOptions: {
        cql_filter: 'ba_name = \'Nagavali\'',
        layerName: 'INDIA_BASIN'
      },
      maxBoundsViscosity: 1.0,
      scrollWheelZoom: false,
      attributionControl: false
      // preferCanvas : true
    },
    godavariTelangana: {
      minZoom: 6,
      maxZoom: 18,
      zoom: 7,
      center: [19.189271694646738, 78.77197265625001],
      zoomControl: false,
      zoomAnimation: true,
    },
    maxBoundsViscosity: 1.0,
    scrollWheelZoom: false,
    attributionControl: false
  },
  FloodForecastBaseLayerOptions: {
    // 'Base Layer': {
    //   url: environment.url.NEW_GEOSERVER_URL + 'gwc/service/wmts?layer=baselayer:floodforecast_base_layer&style&tilematrixset=EPSG:900913&Service=WMTS&Request=GetTile&Version=1.0.0&Format=image/png&TileMatrix=EPSG:900913:{z}&TileCol={x}&TileRow={y}',
    //   options: {
    //     maxZoom: 22,
    //     visible: true,
    //     group: 'group1',
    //     legendData: {
    //       title: 'BASE LAYER',
    //       image: 'img/newGeoportal/legends/base_layer_legend_image.png'
    //     },
    //     imagesrc: '../../../../../../assets/imgs/base-map.jpg',
    //   }
    // }
  },
  FloodForecastMapPanes: [
    {
      name: 'group0',
      zIndex: 580
    },
    {
      name: 'group1',
      zIndex: 581
    },
    {
      name: 'group2',
      zIndex: 582
    },
    {
      name: 'group3',
      zIndex: 583
    },
    {
      name: 'group4',
      zIndex: 584
    },
    {
      name: 'group5',
      zIndex: 585
    },
    {
      name: 'group6',
      zIndex: 588
    }
  ],
  FloodForecastCommonLayers: {
    'South Zone': {
      name: 'South Zone',
      visible: false,
      layeroptions_name: 'VASSARLABS:south_zone',
      layeroptions_min_zoom: 6,
      layeroptions_max_zoom: 12,
      layeroptions_show_on_selector: false,
      layeroptions_pane: 'group1',
      layeroptions_styles: 'VASSARLABS:south_zone',
      type: 'WMS',
      cql_filter: null,
      group: 'Boundaries'
    },
    'South Zone Inverse': {
      name: 'South Zone Inverse',
      visible: false,
      layeroptions_name: 'VASSARLABS:kwaram_south_zone_inverse_v2',
      layeroptions_min_zoom: 6,
      layeroptions_max_zoom: 12,
      layeroptions_show_on_selector: false,
      layeroptions_pane: 'group1',
      // layeroptions_styles: 'forecast:FORECAST_INVERSE_STYLE',
      type: 'WMS',
      cql_filter: null,
      group: 'Boundaries'
    },
    'India Basin Inverse': {
      name: 'India Basin Inverse',
      forecastUrl: true,
      visible: false,
      layeroptions_name: 'forecast:INDIA_BASIN_INVERSE',
      layeroptions_min_zoom: 6,
      layeroptions_max_zoom: 12,
      layeroptions_show_on_selector: false,
      layeroptions_pane: 'group2',
      layeroptions_styles: 'forecast:FORECAST_INVERSE_STYLE',
      type: 'WMS',
      cql_filter: null,
      group: 'Boundaries'
    }
  },
  FloodForecastRiver: {
    Rivers: {
      name: 'Flow in cusecs',
      legendData: {
        title: 'Flow River',
        levels: [
          {
            color: '#7e0000',
            name: '>1M'
          },
          {
            color: '#bb0005',
            name: '500K-1M'
          },
          {
            color: '#fa050c',
            name: '100K-500k'
          },
          {
            color: '#fb7276',
            name: '50K-100K'
          },
          {
            color: '#ffa198',
            name: '25K-50k'
          },
          {
            color: '#003288',
            name: '10K-25K'
          },
          {
            color: '#1560e0',
            name: '5K-10k'
          },
          {
            color: '#4e8ffd',
            name: '2.5K-5K'
          },
          {
            color: '#7dacfb',
            name: '250-2.5K'
          },
          {
            color: '#b6d1ff',
            name: '0-250'
          }
        ]
      }
    },
    'Flow Node': {
      name: 'Flow Point',
      legendData: {
        title: 'Flow Point',
        levels: [
          {
            color: '#ff9900',
            name: 'Forecast',
            image: '../assets/imgs/circle.svg'
          },
          {
            color: '#3399ff',
            name: 'Reservoir',
            image: '../assets/imgs/tringle.svg'
          },
          {
            color: '#006600',
            name: 'River Gauge',
            image: '../assets/imgs/square.svg'
          },
        ]
      }
    }
  },
  floodforecastRiver: {
    Rivers: {
      name: 'Flow in cusecs',
      legendData: {
        title: 'Flow River',
        levels: [
          {
            color: '#7e0000',
            name: '>1M'
          },
          {
            color: '#bb0005',
            name: '500K-1M'
          },
          {
            color: '#fa050c',
            name: '100K-500k'
          },
          {
            color: '#fb7276',
            name: '50K-100K'
          },
          {
            color: '#ffa198',
            name: '25K-50k'
          },
          {
            color: '#003288',
            name: '10K-25K'
          },
          {
            color: '#1560e0',
            name: '5K-10k'
          },
          {
            color: '#4e8ffd',
            name: '2.5K-5K'
          },
          {
            color: '#7dacfb',
            name: '250-2.5K'
          },
          {
            color: '#b6d1ff',
            name: '0-250'
          }
        ]
      }
    },
    'Flow Node': {
      name: 'Flow Point',
      legendData: {
        title: 'Flow Point',
        levels: [
          {
            color: '#ff9900',
            name: 'Forecast',
            image: '../assets/imgs/circle.svg'
          },
          {
            color: '#3399ff',
            name: 'Reservoir',
            image: '../assets/imgs/tringle.svg'
          },
          {
            color: '#006600',
            name: 'River Gauge',
            image: '../assets/imgs/square.svg'
          },
        ]
      }
    }
  }
};
